<template>
  <div>
    <!-- Modal -->
    <div
      data-backdrop="static"
      data-keyboard="false"
      class="modal fade"
      id="Emp_UpdateModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalCenterTitle">
              Updating Service
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <serviceForm formType="put"></serviceForm>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div
        class="col-md-4 my-2 d-print-none d-none d-lg-block d-xl-block d-md-block"
      >
        <serviceForm formType="post"></serviceForm>
      </div>
      <div class="col">
        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Item Name</th>
              <th scope="col">washin</th>
              <th scope="col">ironing</th>
              <th scope="col">Expr washin</th>
              <th scope="col">Expr ironing</th>
              <th scope="col">Edite</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in GetAllService" :key="item._id">
              <th scope="row">{{ index + 1 }}</th>
              <td>{{ item.ItemName }}</td>
              <td>{{ item.price.washingPrice }}</td>
              <td>{{ item.price.ironingPrice }}</td>
              <td>{{ item.price.ExpWashing }}</td>
              <td class=" row mx-auto">{{ item.price.ExpIroning }}</td>
              <td>
                <button class="btn btn-link" @click="OnEdit(index)">
                  <!-- <i class="fa fa-user-edit" aria-hidden="true"></i> -->
                  <i
                    class="fa fa-pencil-square-o text-danger"
                    aria-hidden="true"
                  ></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
// import { required } from "vuelidate/lib/validators";
// import empForm from "@/components/empForm";
import serviceForm from "@/components/serviceForm";
import { eventBuss } from "../main";
export default {
  components: {
    serviceForm
  },
  data() {
    return {
      deletIndex: Number,
      deleteName: String
    };
  },
  computed: {
    GetAllService() {
      return this.$store.getters.GetServices;
    }
  },
  methods: {
    reloadDaa() {
      this.$store.dispatch("SelectAll", {
        url: "/service",
        MutName: "SETAll_Service"
      });
    },
    OnEdit(index) {
      let formData = this.GetAllService[index];
      // eslint-disable-next-line
      $("#Emp_UpdateModal").modal("show");
      eventBuss.$emit("ServiceUpdate12", formData);
    }
  },
  created() {
    this.reloadDaa();
  }
};
</script>
